import type { InitOptions, ReadCallback, Resource } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import {
  getGlobali18nInstance,
  initTranslations,
} from './utils/initTranslations';
import { ReactNode, useEffect } from 'react';

interface Props {
  locale?: 'en' | 'de' | 'es';
  namespace: string[];
  children: ReactNode;
  importFn: (
    language: string,
    namespace: string,
    callback: ReadCallback
  ) => void;
  resources?: Resource;
  supportedLngs?: string[];
  initOptions?: InitOptions;
}

export function I18NextProvider({
  locale = 'en',
  namespace,
  children,
  importFn,
  resources,
  supportedLngs,
  initOptions,
}: Props) {
  const i18nInstance = getGlobali18nInstance();

  if (!i18nInstance.isInitialized) {
    initTranslations({
      locale,
      namespace,
      importFn,
      resources,
      supportedLngs,
      initOptions,
    });
  } else if (i18nInstance.language !== locale) {
    i18nInstance.changeLanguage(locale);
  }

  useEffect(() => {
    if (i18nInstance.language !== locale) {
      // Changing language will cause i18next to handle resource loading .etc.
      i18nInstance.changeLanguage(locale);
    }
  }, [i18nInstance, locale]);

  return (
    <I18nextProvider i18n={i18nInstance} defaultNS={namespace}>
      {children}
    </I18nextProvider>
  );
}
